import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyAnM48GKiRmhCBrJ0DXsX80WJWMlcbQ1L8',
  authDomain: 'papoteai.com',
  projectId: 'papoteai',
  storageBucket: 'papoteai.firebasestorage.app',
  messagingSenderId: '670824072446',
  appId: '1:670824072446:web:ccc6d206ac981dbc6691af',
  measurementId: 'G-GNWVMDQKHJ'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firestore and Auth
const db = getFirestore(app)
const auth = getAuth(app)

export { app, db, auth }
